import { Shield, Lock, Clock, Headphones, Scale } from 'lucide-react';

const badges = [
  {
    icon: Shield,
    label: 'SOC 2 Type II',
    description: 'Compliant',
  },
  {
    icon: Lock,
    label: 'Bank-Level',
    description: 'Encryption',
  },
  {
    icon: Scale,
    label: 'CFTC Regulation',
    description: 'Ready',
  },
  {
    icon: Clock,
    label: '99.9% Uptime',
    description: 'SLA',
  },
  {
    icon: Headphones,
    label: '24/7',
    description: 'Support',
  },
];

export function TrustBadgesSection() {
  return (
    <section className="relative py-12 bg-white border-b border-slate-100">
      <div className="container">
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
          {badges.map((badge) => (
            <div
              key={badge.label}
              className="group flex items-center gap-3 px-4 py-2 hover:-translate-y-0.5 transition-all duration-300"
            >
              <div className="p-2 rounded-lg bg-purple-100 group-hover:bg-purple-200 transition-colors">
                <badge.icon className="h-4 w-4 text-purple-600" />
              </div>
              <div className="text-sm">
                <span className="font-semibold text-slate-800">{badge.label}</span>
                <span className="ml-1 text-slate-500">{badge.description}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
